import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { ISmsTemplate } from 'src/app/models/interfaces/sms-template.interface';
import { SmsTemplateDetailContext } from '../models/sms-template-detail-context';
import { SmsTemplateFormComponent } from '../sms-template-form/sms-template-form.component';

@Component({
    selector: 'app-sms-template-detail',
    imports: [MatTabsModule, SmsTemplateFormComponent],
    templateUrl: './sms-template-detail.component.html',
    styleUrl: './sms-template-detail.component.scss'
})
export class SmsTemplateDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public smsTemplateUpdated: EventEmitter<ISmsTemplate> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: SmsTemplateDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<SmsTemplateDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: SmsTemplateDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param smsTemplate: Infos du modèle de SMS.
     */
    public onSmsTemplateUpdated(smsTemplate: ISmsTemplate) {
        this.smsTemplateUpdated.emit(smsTemplate);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
